import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../../store/AppContext';
import { useAuthStore as useAuthStoreEroski } from '../../../store/AuthContext';
import { HostProvider } from '../../../utils/HostProvider';

interface Props {
  visible: boolean;
  isDigital: boolean;
}

const GraciasForm: FC<Props> = (props) => {
  const { visible, isDigital } = props;
  const dataUser = useAuthStoreEroski();
  const { t } = useTranslation();
  const [load, setLoad] = useState<boolean>(false);
  const dataApp = useAppStore();
  const isCaprabo = HostProvider.isCaprabo();

  const linkContacto = isCaprabo
    ? `${process.env.REACT_APP_API_CAPRABO}/clienteLogado/getTK?fromUrl=${
        process.env.REACT_APP_CLUB_CAPRABO
      }atencion-cliente/&fromApp=${t('caprabo_com')}`
    : `${process.env.REACT_APP_API}/clienteLogado/getTK?fromUrl=${
        process.env.REACT_APP_SERVER_EROSKI_ES
      }${t('link.contacto')}&fromApp=${t('eroski_es')}`;
  useEffect(() => {
    if (dataUser.user.token !== '') setLoad(true);
  }, [dataUser.user.token]);

  const goThrough = () => {
    if (isDigital) {
      dataApp.closeSession();
    } else {
      const isApp = dataUser.user.isApp === 'true';
      if (isApp) {
        const ref = isCaprabo
          ? document.location.href
          : `${process.env.REACT_APP_CLUB_HOME}${t('link.eroskies')}`;
        document.location.href = ref;
      } else {
        const ref = isCaprabo
          ? document.location.href
          : `${process.env.REACT_APP_SERVER_EROSKI_ES}${t('link.eroskies')}`;
        document.location.href = ref;
      }
      // process.env.REACT_APP_CLUB_CAPRABO
    }
  };

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      const element = document.querySelector(
        'section.o-section--large.form-thanks.bloque-form.visible',
      ) as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('go-through-btn').click();
    }
  };
  useEffect(() => {
    if (visible && load) {
      const element = document.querySelector(
        'section.o-section--large.form-thanks.bloque-form.visible',
      ) as HTMLElement;
      element.setAttribute('tabindex', '0');
      element.focus();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      element.addEventListener('keydown', saveInfo, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <>
      {(() => {
        if (load) {
          return (
            <>
              <section
                className={`o-section--large form-thanks bloque-form ${
                  visible ? 'visible' : ''
                }`}
              >
                <div className="container">
                  <h2 className="bloque-datos__title u-text-brand">
                    <span className="divider__square brand-color" />
                    <span className="u-margin-right">
                      {isDigital
                        ? t('datos.baja.thanks-for-trust')
                        : t('datos.header')}
                    </span>
                  </h2>
                  {isDigital || HostProvider.isCaprabo() ? (
                    <p>
                      {t('datos.baja.thanks-body-first-line')}{' '}
                      <span className="link">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a href={linkContacto}>
                          {t('datos.baja.attention-service')}
                        </a>
                      </span>{' '}
                      {t('datos.baja.at-your-service')}
                    </p>
                  ) : (
                    <>
                      <p>{t('datos.baja.unsubscribe-club-done-line1')}</p>
                      <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                          __html: t('datos.baja.unsubscribe-club-done-line2'),
                        }}
                      />
                    </>
                  )}
                  <div className="u-text-right u-margin-top">
                    <button
                      id="go-through-btn"
                      type="button"
                      className="btn btn-primary"
                      onClick={() => goThrough()}
                    >
                      {t('datos.baja.go-to-client-area')}
                    </button>
                  </div>
                </div>
              </section>{' '}
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default GraciasForm;
